import React from "react";

export const Cloud13 = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={28} height={28} rx={1} fill="#F1F2F6" />

    <g
      stroke="#8E97A9"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1={6} y1={14} x2={13} y2={14} />
      <line x1={16.5} y1={14} x2={21.5} y2={14} strokeWidth={3} />
      <line x1={22} y1={21} x2={26} y2={21} />
      <line x1={12} y1={21} x2={19} y2={21} />
      <line x1={21} y1={7} x2={25} y2={7} />
      <line x1={12.5} y1={7} x2={17.5} y2={7} strokeWidth={3} />
      <line x1={4} y1={7} x2={8} y2={7} strokeWidth={4} />
      <line x1={3} y1={21} x2={8} y2={21} strokeWidth={4} />
    </g>
  </g>
);
